export default __webpack_public_path__ + "static/media/search-result.ce5e1875.svg";